import React from "react";
import {
  HomeWrapper,
  CAWrapper,
  AboutWrapper,
  AboutImg,
  AboutContainer,
  AboutPin,
  AboutHead,
  AboutDesc,
  CollectionWrapper,
  CollectionImage,
  CollectionContainer,
  CollectionHead,
  CollectionDesc,
  CollectionOutContainer,
  CollectionPrice,
  CollectionButton,
  TokenComingSoonWrapper,
  TokenComingSoonContainer,
  MembershipComingSoonContainer,
  MembershipComingSoonWrapper,
} from "./style";
import { AppLayout } from "../../layout/Index";
import Comingsoon from "./comingsoon/Index";
import Imagination from "./imagination";
import Generate from "./generate";
import Feature from "./feature";
import Effortless from "./effortless";
import Teamlogo from "../../assets/img/team-logo.png";

const Home = () => {
  return (
    <AppLayout>
      <HomeWrapper>
        <div className="team-logo">
          <img src={Teamlogo} alt="team logo" />
        </div>
        <CAWrapper>
          <AboutWrapper>
            <AboutContainer>
              <AboutPin data-aos="fade-right">Only on Polygon zkEVM</AboutPin>
              <AboutHead data-aos="fade-right">
                Innovate Your Imagination with <strong>Stellar Art</strong>
              </AboutHead>
              <AboutDesc>
                <p data-aos="fade-right">
                  Revolutionize your creative journey with Stellar Art, the
                  ultimate fusion of human ingenuity and AI brilliance. We're
                  not just a platform; we're a galaxy of possibilities, born at
                  the cutting-edge intersection of art and technology,
                  exclusively on Polygon zkEVM.
                </p>
                <p data-aos="fade-right">
                  Awaken Your Inner Artist with our AI Image Generator
                </p>
                <br />
                <p data-aos="fade-right">
                  Experience the power of creation like never before. Our
                  dynamic AI Image Generator transforms thoughts into
                  awe-inspiring visuals with a simple click. With over 30
                  advanced models at your fingertips, you're the artist and the
                  muse, the dreamer and the doer. Stellar Art’s advanced AI
                  algorithms redefine creativity, providing lightning-fast
                  results that stun and inspire.
                </p>
                <br />
                <p data-aos="fade-right">
                  <strong>Stellar Art</strong> – Simplicity, Speed, and
                  Spectacular results, backed by Stability AI's revolutionary
                  Stable Diffusion Technology.
                </p>
              </AboutDesc>
            </AboutContainer>
            <AboutImg data-aos="fade-left">
              <img src="assets/card.png" alt="" />
            </AboutImg>
          </AboutWrapper>
          <CollectionWrapper>
            <CollectionOutContainer>
              <CollectionImage data-aos="fade-right">
                <img src="assets/card2.png" alt="collection art" />
              </CollectionImage>
              <CollectionContainer>
                <CollectionHead data-aos="fade-left">
                  Unlock a Universe of Creativity with Stellar Artist NFT
                  Collection
                </CollectionHead>
                <CollectionDesc data-aos="fade-left">
                  <p>
                    Step into the future with our Stellar Artist NFT,
                    exclusively on Polygon zkEVM. It’s not just a digital asset;
                    it's an all-access pass to a world without creative
                    boundaries. With this coveted key, you gain a lifetime
                    subscription to Stellar Art’s AI Image Generator, a treasure
                    trove of over 30 state-of-the-art models for generating
                    unique AI masterpieces.
                  </p>
                </CollectionDesc>
                <CollectionPrice data-aos="fade-left">
                  <p>Limited Edition: Only 500 NFTs</p>
                  <p>Mint Price: 0.05 ETH</p>
                </CollectionPrice>
                <CollectionButton data-aos="fade-left">
                  <a
                    href="https://app.stellartai.com/mint"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Mint Stellar Artist NFT
                  </a>
                </CollectionButton>
                <CollectionHead data-aos="fade-left">
                  Exclusive Holder Perks
                </CollectionHead>
                <CollectionDesc>
                  <li data-aos="fade-left">
                    Early access to unreleased beta models
                  </li>
                  <li data-aos="fade-left">
                    Lifelong Stellar Art AI Image Generator subscription
                  </li>
                  <li data-aos="fade-left">
                    Unrestricted access to cutting-edge AI artistry models
                  </li>
                  <li data-aos="fade-left">
                    Future privileges as our platform grows, opening new doors
                    of opportunities and benefits
                  </li>
                </CollectionDesc>
              </CollectionContainer>
            </CollectionOutContainer>
          </CollectionWrapper>
        </CAWrapper>
        <Effortless />
        <Imagination />
        <Generate />
        <Feature />
        <TokenComingSoonWrapper>
          <TokenComingSoonContainer data-aos="zoom-in" data-aos-delay="1200">
            <img src="assets/Vector.png" alt="" />
            <p>Token Coming Soon</p>
          </TokenComingSoonContainer>
        </TokenComingSoonWrapper>
        <MembershipComingSoonWrapper>
          <MembershipComingSoonContainer
            data-aos="zoom-in"
            data-aos-delay="1200"
          >
            <img src="assets/Vector.png" alt="" />
            <p>Memberships Coming Soon</p>
          </MembershipComingSoonContainer>
        </MembershipComingSoonWrapper>
        <Comingsoon />
      </HomeWrapper>
    </AppLayout>
  );
};

export default Home;
